import React from "react";
import { useTranslation } from "react-i18next";
import type { EmailDeliverabilityStatus as Status } from "../utils/emailDeliverability";
import "./EmailDeliverabilityStatus.css";

const STATUS_CLASS: Record<Exclude<Status, "idle">, string> = {
  checking: "is-checking",
  valid: "is-valid-msg",
  invalid: "is-invalid-msg",
  unknown: "is-unknown-msg",
};

const STATUS_KEY: Record<Exclude<Status, "idle">, string> = {
  checking: "email_checking",
  valid: "email_domain_valid",
  invalid: "email_domain_invalid",
  unknown: "email_domain_unknown",
};

export default function EmailDeliverabilityStatus({
  status,
}: {
  status: Status;
}) {
  const { t } = useTranslation();
  if (status === "idle") return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`email-deliverability-status ${STATUS_CLASS[status]}`}
    >
      {t(STATUS_KEY[status])}
    </div>
  );
}
